var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticStyle:{"float":"right"}},[_c('a',{attrs:{"href":_vm.$t(_vm.helpLink),"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('common.needHelp')))]),_vm._v("   ")]),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }